import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchPorcentajeIvaServicios, useUpdatePorcentajeIvaServicios } from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { PORCENTAJEIVASERVICIOS } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrlPRIVA = '/parametrizacion/porcentajes-ret-iva-servicios';

export interface PorcentajeIvaServiciosPageInterface {}

const PorcentajeIvaServiciosPage: React.FC<PorcentajeIvaServiciosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_porcentajeretivaservicios);

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: PorcentajeIvaServiciosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchPorcentajeIvaServicios({
    page: pageIndex + 1,
    codigo: searchTerm,
  });

  ///* mutations
  const updatePorcentajeIvaServiciosMutation = useUpdatePorcentajeIvaServicios({navigate, returnUrl:returnUrlPRIVA});

  ///* handlers
  const onEdit = (original: PORCENTAJEIVASERVICIOS) => {
    navigate(`${returnUrlPRIVA}/editar/${original.id_porcentaje_ret_iva_servicios}`);
  };
    ///* global state
    const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
    const setConfirmDialogIsOpen = useUiConfirmModalStore(
      s => s.setConfirmDialogIsOpen
    );

  ///* columns
  const columns = useMemo<MRT_ColumnDef<PORCENTAJEIVASERVICIOS>[]>(
    () => [
      /* {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 300,
      }, */
      {
        accessorKey: 'porcentaje',
        header: 'Porcentaje',
        size: 300,
        Cell: ({ row }) => <div>% {row.original.porcentaje}</div>,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={iva => {
              if (!hasPermission(PermissionsEnum.api_change_porcentajeretivaservicios)) return;
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updatePorcentajeIvaServiciosMutation.mutate({
                    id: row.original.id_porcentaje_ret_iva_servicios!,
                    data: {
                      ...row.original,
                      estado: iva as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Porcentaje de IVA servicios" urlRedirect={`${returnUrlPRIVA}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_porcentajeretivaservicios)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Porcentaje de iva servicios" />

      <GeneralTable<PORCENTAJEIVASERVICIOS>
        columns={columns}
        data={PorcentajeIvaServiciosPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={PorcentajeIvaServiciosPagingRes?.data?.count}
        enableColumnActions={hasPermission(PermissionsEnum.api_change_porcentajeretivaservicios)}
        // // actions
        actionsColumnSize={120}
        // crud
        canEdit={hasPermission(PermissionsEnum.api_change_porcentajeretivaservicios)}
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default PorcentajeIvaServiciosPage;
